/****************************************************
 * Module Name:  offerProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class OfferProxy {

  static GetCustomersCreatedOffer = (userid, usertype, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/offer/customers/${userid}/${usertype}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetOfferDetailForCustomer = (userid, usertype, customeridsList, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/offer/customer/${userid}/${usertype}/detail`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(customeridsList),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetOfferDataByStone = (stoneidsList, userid, usertype, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/offer/stone/${userid}/${usertype}/detail`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(stoneidsList),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

}
